import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Forside from "@/pages/Forside";
import Hjerneregulering from "@/pages/Hjerneregulering";
import Neurofeedback from "@/pages/Neurofeedback";
import Forloeb from "@/pages/Forloeb";
import Om from "@/pages/Om";
import Viden from "@/pages/Viden";
import Artikel from "@/pages/Artikel";
import Kontakt from "@/pages/Kontakt";

let lenis = null;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen overflow-x-hidden bg-canvas text-charcoal">
        <Navigation />
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/hjerneregulering" element={<Hjerneregulering />} />
          <Route path="/neurofeedback" element={<Neurofeedback />} />
          <Route path="/forloeb" element={<Forloeb />} />
          <Route path="/om" element={<Om />} />
          <Route path="/viden" element={<Viden />} />
          <Route path="/viden/:slug" element={<Artikel />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              background: "#0A0A0A",
              color: "#F5F5F0",
              border: "1px solid #272725",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: "14px",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
